import { forwardRef } from "react";
import cx from "classnames";

import styles from "./styles.module.css";
import Box, { BoxProps } from "../Box";

type DraggableItemProps = BoxProps & {
  size?: "small" | "medium";
  disabled?: boolean;
  dragging?: boolean;
  noBorder?: boolean;
};

const DraggableItem = forwardRef(function DraggableItem(
  props: DraggableItemProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const {
    className,
    size = "medium",
    disabled,
    dragging,
    children,
    noBorder,
    style,
    ...rest
  } = props;

  return (
    <Box
      ref={ref}
      className={cx(
        styles.wrapper,
        styles[size],
        {
          [styles.disabled]: disabled,
          [styles.dragging]: dragging,
          [styles.noBorder]: noBorder,
        },
        className
      )}
      style={style}
      {...rest}
    >
      {children}
    </Box>
  );
});

DraggableItem.displayName = "DS.DraggableItem";

export default DraggableItem;
